import { render, staticRenderFns } from "./cargosDetails.vue?vue&type=template&id=4e3fb980&"
import script from "./cargosDetails.vue?vue&type=script&lang=js&"
export * from "./cargosDetails.vue?vue&type=script&lang=js&"
import style0 from "./cargosDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports